import React, { Component } from 'react'
import moment from 'moment'
import {
  Form,
  Select,
  message,
  notification,
  Modal,
  Input,
  Button,
} from 'antd'
import _ from 'lodash'
import $ from 'jquery'
import AppHelper from 'libs/AppHelper'
import { API_HOST } from '../../configs/env'
import whttp from '../../libs/whttp'
import Errors from 'validatorjs/src/errors'
import { genFormItemAtrribute } from 'libs/FormHelper'
import { __ } from '@wordpress/i18n'
import styles from './styles.module.scss'

const VC_CONFIG = window.VC_CONFIG
const Local = _.get(window, 'VC_CONFIG.Locale')

const defaultListInfo = {
  current: 1, //目前頁數
  page_size: 10, //一頁幾筆
  total: 1, //以此query條件，總共幾筆資料
  rows: [],
}
const Option = Select.Option
// 前端頁面
export default class UserInvoiceCarrierConsolidation extends Component {
  formRef = React.createRef()

  state = {
    selectedCard: '',
    card_type: null,
    cardOptions: [],
    query: {},
    listInfo: _.cloneDeep(defaultListInfo),
    memberVip: 0,
    memberOpen: 0,
    memberType: 0, // 0: 一般會員; 1: VIP; 2: 一般會員 OP會員; 3: VIP OP會員
    memberLinkcode: '',
    bonusPoint: 0,
    bonusPointDiscount: 0,
    openPoint: 0,
    openPointDiscount: 0,
    tableData: [],
    selectmonth: moment()
      .startOf('month')
      .format('YYYY-MM-DD'),
    isLoading: true,
    cardNumbersList: Array(4).fill(''),
  }

  componentDidMount() {
                        this.getMemberProfile()
                        this.loadHKCards()
                        this.setState(
                          { info: this.props.user },
                          () => {
                            this.reloadTab()
                          }
                        )
                      }

  focusCreditCardInput = (e) => {
    if (/^\d*$/.test(e.target.value)) {
      const currentInput = e.target.value
      const maxLength = 4
      const newArray = [...this.state.cardNumbersList]

      switch (e.target.id) {
        case 'credit-card-input-1':
          currentInput.length === maxLength &&
            document.querySelector('#credit-card-input-2').focus()
          this.setState({
            cardNumbersList: newArray.fill(currentInput, 0, 1),
          })
          break
        case 'credit-card-input-2':
          currentInput.length === maxLength &&
            document.querySelector('#credit-card-input-3').focus()
          this.setState({
            cardNumbersList: newArray.fill(currentInput, 1, 2),
          })
          break
        case 'credit-card-input-3':
          currentInput.length === maxLength &&
            document.querySelector('#credit-card-input-4').focus()
          this.setState({
            cardNumbersList: newArray.fill(currentInput, 2, 3),
          })
          break
        case 'credit-card-input-4':
          this.setState({
            cardNumbersList: newArray.fill(currentInput, 3, 4),
          })
          break
        default:
          break
      }
    }
  }

  reloadTab = () => {
    // tab 共用動態
    var $el, leftPos, newWidth
    /* Add Magic Line markup via JavaScript, because it ain't gonna work without */
    let $magicLine = $('#magic-line')

    if (!_.get($magicLine, 0)) {
      console.log('kkk c', $magicLine)
      $('.basic-tabs-label ul').append("<li id='magic-line'></li>")
    }
    /* Cache it */
    $magicLine = $('#magic-line')

    $magicLine
      .width($('.current_page_item').width())
      .css('left', $('.current_page_item a').position().left)
      .data('origLeft', $magicLine.position().left)
      .data('origWidth', $magicLine.width())

    $('.basic-tabs-label ul li a').unbind('mouseenter mouseleave')
    $('.basic-tabs-label ul li')
      .find('a')
      .hover(
        function() {
          $el = $(this)
          console.log('basic-tabs-label', $el)
          leftPos = $el.position().left
          newWidth = $el.parent().width()

          $magicLine.stop().animate({
            left: leftPos,
            width: newWidth,
          })
        },
        function() {
          $magicLine.stop().animate({
            left: $magicLine.data('origLeft'),
            width: $magicLine.data('origWidth'),
          })
        }
      )

    $('#pills-tab .nav-item').unbind('mouseenter mouseleave')
    $('#pills-tab .nav-item')
      .mouseenter(function() {
        if (!$(this).hasClass('highlight')) {
          $('.highlight').removeClass('current_page_item')
        }
      })
      .mouseleave(function() {
        $('.highlight').addClass('current_page_item')
      })
  }

  loadHKCards = () => {
    const { page, page_size } = {
      page: 1,
      page_size: 'all',
    }

    this.setState({ isLoadingData: true })

    whttp.get(
      API_HOST + '/api/account/oca/getCCEInvoiceCarrierList',
      {},
      (state, res) => {
        this.setState({ isLoadingData: false })

        const { code = 100, reason = '發生錯誤', data = {} } = res
        console.log(code, reason, data, res)

        if (state === false) {
          return console.log('55555555555555555555')
        } //this.setState({ message: '發生錯誤' }); }

        if (code !== 200) {
          return console.log('66666666666666666666')
        } //this.setState({ message: reason }); }

        console.log('getEInvoiceCarrierList', data)

        this.setState({
          cardOptions: data,
        })
      }
    )
  }

  getMemberProfile = () => {
    whttp.get(
      API_HOST + `/api/account/cc/getProfiles`,
      {},
      (state, res) => {
        console.log('getProfiles', `/api/account/cc/getProfiles`, res)
        this.setState({ isSubmitData: false })

      const { code = 100, reason = '發生錯誤', data = {} } = res

      if (code !== 200) {
        Modal.error({
          title: '資料讀取失敗',
          content: reason,
        })

        console.log('資料讀取失敗： ', reason)

        return this.setState({
          messages: data.messages || {},
        })
      }
      console.log('getProfiles', data)
      this.setState({
        memberVip: data.member_profile_isvip,
        memberOpen: data.member_profile_isopen,
        memberLinkcode: data.member_profile_linkcode,
        bonusPoint: parseInt(data.member_account_value, 10),
        bonusPointDiscount: parseInt(data.member_account_value / 300, 10),
        openPoint: data.member_open_value,
        openPointDiscount: parseInt(data.member_open_value, 10),
        memberType: (data.member_profile_isvip == 0 && data.member_profile_isopen == 0) ? 0 :
                    (data.member_profile_isvip == 1 && data.member_profile_isopen == 0) ? 1 :
                    (data.member_profile_isvip == 0 && data.member_profile_isopen == 1) ? 2 :
                    (data.member_profile_isvip == 1 && data.member_profile_isopen == 1) ? 3 : 0,
      })
    })
  }

  submitData = () => {
    const { cardNumbersList } = this.state
    this.setState({
      isSubmitData: true,
      messages: {},
    })
    whttp.post(
      API_HOST + `/api/account/oca/getEInvoiceCarrierConsolidationData`,
      {
        card:
          this.state.selectedCard === 'null'
            ? cardNumbersList[0] +
              cardNumbersList[1] +
              cardNumbersList[2] +
              cardNumbersList[3]
            : this.state.selectedCard,
        type: _.get(this, 'state.card_type'),
      },
      (state, res) => {
        this.setState({ isSubmitData: false })
        const { code = 100, reason = '發生錯誤', data = {} } = res

        if (state === false) {
          return message.error('發生錯誤')
        }

        if (code !== 200) {
          notification['error']({
            message: '發生錯誤',
            description: reason,
          })
          return this.setState({
            messages: data.messages || {},
          })
        }
        // 發送post給財政部
        Modal.destroyAll()
        Modal.confirm({
          title: '即將離開本網站，前往財政部電子發票歸戶平台',
          cancelText: '取消',
          okText: '離開本網站，並進行發票歸戶',
          onCancel: null,
          onOk: () => {
            const form = document.createElement('form')
            form.setAttribute('method', 'post')
            form.setAttribute('action', _.get(data, 'url'))
            form.setAttribute('target', 'view')
            _.forEach(data, (v, k) => {
              console.log(`${k}=${v}`)
              var input = document.createElement('input')
              input.type = 'hidden'
              input.name = k
              input.value = v
              form.appendChild(input)
            })
            document.body.appendChild(form)
            window.open('', 'view')
            form.submit()
          },
        })
      }
    )
  }

  refreshPicker = _.debounce(() => {
    $('.selectpicker').selectpicker('refresh')
  }, 1000)

  wincode = (num) => {
    var codeA = '特別獎 1000萬'
    var codeB = '千元獎 2000元'
    var codeC = '百萬獎 100萬'
    var code = [
      '特　獎 200萬',
      '頭　獎 20萬',
      '二　獎 <br> 4萬',
      '三　獎 <br> 1萬',
      '四　獎 4,000元',
      '五　獎 1,000元',
      '六　獎 200元',
    ]
    if (num === 'A') {
      return codeA || '??'
    } else if (num === 'B') {
      return codeB || '??'
    } else if (num === 'C') {
      return codeC || '??'
    } else {
      num = parseInt(num, 10)
      return code[num] || '??'
    }
  }

  nonwincode = (date) => {
    if (date) {
      var getDate = moment(date)
      var currDate = moment()
      if (moment(getDate).isBefore(currDate)) {
        var getDateMonth = getDate.format('M')
        var currDateMonth = currDate.format('M')
        var currDateDay = currDate.format('D')
        var diffMonth = Math.abs(currDateMonth - getDateMonth)

        if (currDateMonth >= 7) {
          //7-12月
          if (diffMonth > 2) {
            if (localStorage.getItem('setlang') == 'en') {
              return "Didn't win a Prize"
            } else {
              return '未中獎'
            }
          } else {
            if (currDateMonth % 2 == 0) {
              //偶數月
              if (diffMonth > 1) {
                if (localStorage.getItem('setlang') == 'en') {
                  return "Didn't win a Prize"
                } else {
                  return '未中獎'
                }
              } else {
                if (localStorage.getItem('setlang') == 'en') {
                  return '未開獎'
                } else {
                  return '未開獎'
                }
              }
            } else {
              //開獎月(奇數月)
              if (diffMonth == 0) {
                if (localStorage.getItem('setlang') == 'en') {
                  return '未開獎'
                } else {
                  return '未開獎'
                }
              } else {
                if (currDateDay > 25) {
                  // 已開獎
                  if (localStorage.getItem('setlang') == 'en') {
                    return "Didn't win a Prize"
                  } else {
                    return '未中獎'
                  }
                } else {
                  if (localStorage.getItem('setlang') == 'en') {
                    return '未開獎'
                  } else {
                    return '未開獎'
                  }
                }
              }
            }
          }
        } else {
          if (diffMonth > 2 && diffMonth < 10) {
            if (localStorage.getItem('setlang') == 'en') {
              return "Didn't win a Prize"
            } else {
              return '未中獎'
            }
          } else {
            if (currDateMonth % 2 == 0) {
              //偶數月
              if (diffMonth <= 1) {
                if (localStorage.getItem('setlang') == 'en') {
                  return '未開獎'
                } else {
                  return '未開獎'
                }
              } else {
                if (localStorage.getItem('setlang') == 'en') {
                  return "Didn't win a Prize"
                } else {
                  return '未中獎'
                }
              }
            } else {
              //開獎月(奇數月)
              if (diffMonth == 0) {
                if (localStorage.getItem('setlang') == 'en') {
                  return '未開獎'
                } else {
                  return '未開獎'
                }
              } else {
                if (currDateDay > 25) {
                  // 已開獎
                  if (localStorage.getItem('setlang') == 'en') {
                    return "Didn't win a Prize"
                  } else {
                    return '未中獎'
                  }
                } else {
                  if (localStorage.getItem('setlang') == 'en') {
                    return '未開獎'
                  } else {
                    return '未開獎'
                  }
                }
              }
            }
          }
        }
      } else {
        if (localStorage.getItem('setlang') == 'en') {
          return '無法判斷'
        } else {
          return '無法判斷'
        }
      }
    } else {
      if (localStorage.getItem('setlang') == 'en') {
        return '無法判斷'
      } else {
        return '無法判斷'
      }
    }
  }

  render() {
    const errors = _.get(this, 'state.validator.errors', new Errors())
    const options = _.get(this, 'props.app.options', {})
    const { cardOptions, info = [], cardNumbersList, selectedCard } = this.state
    const MemberVip = this.state.memberVip
    const MemberOpen = this.state.memberOpen
    // 新增用戶類型
    const MemberType = this.state.memberType
    const MemberLinkcode = this.state.memberLinkcode
    const BonusPoint = this.state.bonusPoint
    const BonusPointDiscount = this.state.bonusPointDiscount
    const OpenPoint = this.state.openPoint
    const OpenPointDiscount = this.state.openPointDiscount

    const memberCardImages = {
      0: `${VC_CONFIG.INDEX_URL}/wp-content/themes/cec/assets/img/membercard/card-cec-2025.png`, // 一般會員
      1: `${VC_CONFIG.INDEX_URL}/wp-content/themes/cec/assets/img/membercard/card-cec-vvip-2025.png`, // VIP
      2: `${VC_CONFIG.INDEX_URL}/wp-content/themes/cec/assets/img/membercard/card-openpoint-2025.png`, // 一般會員 OP會員
      3: `${VC_CONFIG.INDEX_URL}/wp-content/themes/cec/assets/img/membercard/card-cec-vvip-2025.png`, // VIP OP會員
    }

    var date = new Date(),
      y = date.getFullYear(),
      m = date.getMonth()
    var firstDay = new Date(y, m, 1)
    var lastDay = new Date(y, m + 1, 0)
    var tmpStr_area = '',
      tmpResult_area =
        '<option value="' +
        moment(firstDay).format('YYYY-MM-DD') +
        '">' +
        moment(firstDay).format('YYYY年MM月') +
        '</option>'
    for (var i = 0; i < 5; i++) {
      tmpStr_area =
        '<option value="' +
        moment(firstDay)
          .subtract(1, 'months')
          .format('YYYY-MM-DD') +
        '">' +
        moment(firstDay)
          .subtract(1, 'months')
          .format('YYYY年MM月') +
        '</option>'
      tmpResult_area = tmpResult_area + tmpStr_area
      firstDay = moment(firstDay)
        .subtract(1, 'months')
        .format('YYYY-MM-DD')
      lastDay = moment(lastDay)
        .subtract(1, 'months')
        .format('YYYY-MM-DD')
    }
    $('#SelectMonth').html(tmpResult_area)

    this.refreshPicker()

    const currentCard =
      cardOptions.find((item) => {
        return String(item.id) === this.state.selectedCard
      }) || {}
    const selectedTypeName = currentCard.typeName

    return (
      <div>
        <main className='bg-light'>
          <div className='container'>
            <section className='pt-2 pb-2'>
              <div className='breadcrumb-wrap'>
                <nav aria-label='breadcrumb'>
                  {Local == 'zh_TW' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/profile`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'>
                        {__('電子發票紀錄', 'cec-plugin-stores')}
                      </li>
                    </ol>
                  )}
                  {Local == 'en_US' && (
                    <ol className='breadcrumb'>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/en`}>
                          {__('首頁', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li className='breadcrumb-item'>
                        <a href={`${VC_CONFIG.INDEX_URL}/profile-en`}>
                          {__('會員中心', 'cec-plugin-stores')}
                        </a>
                      </li>
                      <li
                        className='breadcrumb-item active'
                        aria-current='page'>
                        {__('電子發票紀錄', 'cec-plugin-stores')}
                      </li>
                    </ol>
                  )}
                </nav>
              </div>
              <h6 className='h5 lh-h4 mb-5 text-navy text-lg-left text-center'>
                {__('親愛的', 'cec-plugin-stores')}{' '}
                <b className='fw-700'>{info && info.name}</b>
                <br className='d-block d-lg-none' />
                {__('您好，歡迎來到會員中心！', 'cec-plugin-stores')}
              </h6>
              <div class='row no-gutters mx-n3 mb-4'>
                <div class='col-lg-4 px-3'>
                  <div class='card border-0 shadow-0 h-100'>
                    <div class='card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'>
                      <div
                        class='hkcardontop'
                        style={{
                          textAlign: 'center',
                        }}>
                        {/* <img
                          style={{
                            maxWidth: '180px',
                          }}
                          className='img-contain'
                          src={
                            memberCardImages[MemberType] ||
                            memberCardImages[0]
                          }
                          alt=''
                        /> */}
                      </div>
                      {/*class="h3 text-navy text-center pt-3">好康卡</h5>*/}
                    </div>
                  </div>
                </div>
                <div class='col-lg-8 px-3'>
                  <div class='card border-0 shadow-0 h-100'>
                    <div class='card-body'>
                      <ul class='h6 text-navy text-justify list-unstyled'>
                        <li class='pb-1'>
                          會員等級：{' '}
                          {MemberVip == 0 ? (
                            <span style={{ color: '#1E5BC6' }}>
                              一般會員
                            </span>
                          ) : (
                            <img
                              src={`${
                                VC_CONFIG.INDEX_URL
                              }/wp-content/themes/cec/assets/img/member/tag-vvip-2025.png`}
                              alt='VIP'
                              style={{ width: '60px', height: '17px' }}
                            />
                          )}
                          {MemberOpen == 1 && (
                            <img
                              src={`${
                                VC_CONFIG.INDEX_URL
                              }/wp-content/themes/cec/assets/img/member/tag-openpoint-2025.png`}
                              alt='uniopen'
                              style={{ width: '60px', height: '17px' }}
                            />
                          )}
                        </li>
                        {/* <li class='pb-1'>
                          會員卡號：
                          <span style={{ color: '#1E5BC6' }}>
                            {MemberLinkcode}
                          </span>
                        </li> */}
                      </ul>
                      <div class='row'>
                        {/* 紅利點數卡片 */}
                        <div class='col-md-6 my-2'>
                          <div
                            class='card border-0 shadow-sm'
                            style={{ background: '#EBEBEB' }}>
                            <div class='card-body text-center'>
                              <div
                                div
                                className='mb-3 d-flex justify-content-center'>
                                <img
                                  src={`${
                                    VC_CONFIG.INDEX_URL
                                  }/wp-content/themes/cec/assets/img/member/cec-point-2025.png`}
                                  alt='紅利點數圖示'
                                  style={{ width: '24px', height: '24px' }}
                                />
                              </div>
                              <p class='h4 text-navy'>
                                好康點數：{BonusPoint} 點
                              </p>
                              <p class='h6 text-success'>
                                可兌換金額：{BonusPointDiscount} 元
                              </p>
                            </div>
                          </div>
                        </div>
                        {/* OPEN POINT 點數卡片 */}
                        <div class='col-md-6 my-2'>
                          <div
                            class='card border-0 shadow-sm'
                            style={{ background: '#EBEBEB' }}>
                            <div class='card-body text-center'>
                              <div
                                div
                                className='mb-3 d-flex justify-content-center'>
                                <img
                                  src={`${
                                    VC_CONFIG.INDEX_URL
                                  }/wp-content/themes/cec/assets/img/member/open-point-2025.svg`}
                                  alt='OPENPOINT圖示'
                                  style={{ width: '24px', height: '24px' }}
                                />
                              </div>
                              <p class='h4 text-navy'>
                                OPENPOINT：{OpenPoint} 點
                              </p>
                              <p class='h6 text-success'>
                                可兌換金額：{OpenPointDiscount} 元
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <p class='h6 pt-4 text-font text-justify'>
                        *顯示之點數視消費情況更新！如遇資料交換造成點數延遲異動，以電腦系統為準。
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <section className='pt-0'>
            <div className='mb-5 basic-tabs-label'>
              {Local == 'zh_TW' && (
                <ul className='nav nav-pills' id='pills-tab'>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/profile`}>
                      {__('我的帳戶', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/pwd`}>
                      {__('更改密碼', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* <li className='nav-item'>
                    <a
                      className='nav-link '
                      href={`${VC_CONFIG.INDEX_URL}/payment`}
                    >
                      {__('我的消費紀錄', 'cec-plugin-stores')}
                    </a>
                  </li> */}
                  <li className='nav-item current_page_item highlight'>
                    <a className='nav-link ' href='#'>
                      {__('發票歸戶', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* {info && info.spcode === 'C4' &&
                    <li className="nav-item"><a className="nav-link" href={`${VC_CONFIG.INDEX_URL}/pwd`}>{__('更改密碼', 'cec-plugin-stores')}</a></li>
                  } */}
                  {/* <li className="nav-item"><a className="nav-link" href={`${VC_CONFIG.INDEX_URL}/loyaltyprofile`}>{__('好康卡會員資料', 'cec-plugin-stores')}</a></li>
                  <li className="nav-item"><a className="nav-link" href={`${VC_CONFIG.INDEX_URL}/point`}>{__('點數紀錄', 'cec-plugin-stores')}</a></li>
                  <li className="nav-item current_page_item highlight"><a className="nav-link" >{__('電子發票記錄', 'cec-plugin-stores')}</a></li>
                  <li className="nav-item"><a className="nav-link" href={`${VC_CONFIG.INDEX_URL}/connect`}>{__('第三方登入設定', 'cec-plugin-stores')}</a></li> */}
                </ul>
              )}
              {Local == 'en_US' && (
                <ul className='nav nav-pills' id='pills-tab'>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/profile-en`}>
                      {__('我的帳戶', 'cec-plugin-stores')}
                    </a>
                  </li>
                  <li className='nav-item'>
                    <a
                      className='nav-link'
                      href={`${VC_CONFIG.INDEX_URL}/pwd-en`}>
                      {__('更改密碼', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* <li className='nav-item'>
                    <a
                      className='nav-link '
                      href={`${VC_CONFIG.INDEX_URL}/payment-en`}
                    >
                      {__('我的消費紀錄', 'cec-plugin-stores')}
                    </a>
                  </li> */}
                  <li className='nav-item current_page_item highlight'>
                    <a className='nav-link ' href='#'>
                      {__('發票歸戶', 'cec-plugin-stores')}
                    </a>
                  </li>
                  {/* {info && info.spcode === 'C4' &&
                    <li className="nav-item"><a className="nav-link" href={`${VC_CONFIG.INDEX_URL}/pwd-en`}>{__('更改密碼', 'cec-plugin-stores')}</a></li>
                  } */}
                  {/* <li className="nav-item"><a className="nav-link" href={`${VC_CONFIG.INDEX_URL}/loyaltyprofile-en`}>{__('好康卡會員資料', 'cec-plugin-stores')}</a></li>                  
                  <li className="nav-item"><a className="nav-link" href={`${VC_CONFIG.INDEX_URL}/point-en`}>{__('點數紀錄', 'cec-plugin-stores')}</a></li>
                  <li className="nav-item current_page_item highlight"><a className="nav-link" >{__('電子發票記錄', 'cec-plugin-stores')}</a></li>
                  <li className="nav-item"><a className="nav-link" href={`${VC_CONFIG.INDEX_URL}/connect-en`}>{__('第三方登入設定', 'cec-plugin-stores')}</a></li> */}
                </ul>
              )}
            </div>
            <div className='container'>
              <div className='shadow-0 rounded-10 mb-4'>
                <div className='card-body p-5'>
                  <h4 className='heading-title align-items-center'>
                    {__('會員卡歸戶', 'cec-plugin-stores')}
                  </h4>
                  <hr className='border-top border-gray mt-0 mb-5' />
                  <div className='row align-items-center justify-content-center'>
                    <div className='col-md-6 mb-5 mb-md-0'>
                      <div className='row mb-4'>
                        <div className='col-7 mx-auto'>
                          <img
                            className='img-contain'
                            src={`${
                              VC_CONFIG.INDEX_URL
                            }/wp-content/themes/cec/assets/img/membercard/credit_card2.svg`}
                            alt=''
                          />
                        </div>
                      </div>
                    </div>
                    <div className='col-md-6'>
                      <div className='row mb-4'>
                        <div className='col-9 col-md-8 mx-auto'>
                          <Form.Item {...genFormItemAtrribute('card')}>
                            <Select
                              placeholder='選擇會員卡'
                              onChange={(card) => {
                                const temCard = card.split('_')
                                this.setState({
                                  selectedCard: temCard[0],
                                  card_type: temCard[1],
                                  cardNumbersList: Array(4).fill(''),
                                })
                              }}>
                              {_.map(cardOptions, (item) => (
                                <Option value={`${item.id}_${item.type}`}>
                                  {`${item.id.slice(0, 7)}******${item.id.slice(13)}`}
                                </Option>
                              ))}
                            </Select>
                          </Form.Item>
                          {selectedTypeName === '聯名卡' && (
                            <div
                              className={styles['credit-card-input-outer']}>
                              <Form.Item>
                                <div
                                  className={
                                    styles['credit-card-input-inner']
                                  }>
                                  <Input
                                    id='credit-card-input-1'
                                    className={styles['credit-card-input']}
                                    maxLength={4}
                                    value={cardNumbersList[0]}
                                    onChange={this.focusCreditCardInput}
                                  />
                                  -
                                  <Input
                                    id='credit-card-input-2'
                                    className={styles['credit-card-input']}
                                    maxLength={4}
                                    value={cardNumbersList[1]}
                                    onChange={this.focusCreditCardInput}
                                  />
                                  -
                                  <Input
                                    id='credit-card-input-3'
                                    className={styles['credit-card-input']}
                                    maxLength={4}
                                    value={cardNumbersList[2]}
                                    onChange={this.focusCreditCardInput}
                                  />
                                  -
                                  <Input
                                    id='credit-card-input-4'
                                    className={styles['credit-card-input']}
                                    maxLength={4}
                                    value={cardNumbersList[3]}
                                    onChange={this.focusCreditCardInput}
                                  />
                                </div>
                              </Form.Item>
                            </div>
                          )}
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-9 col-md-8 mx-auto'>
                          {/* <a
                            class='h6 btn btn-block btn-outline-primary rounded-pill py-4'
                            role='button'
                            href={
                              info &&
                              `https://account.uni-prosperity.com.tw/einvoice/cards?gid=${
                                info.gid
                              }`
                            }
                            target='_blank'
                            rel='noopener noreferrer'
                            onClick={(e) => {
                              e.preventDefault();
                              this.submitData();
                            }}
                          >
                            {__('開始歸戶', 'cec-plugin-stores')}
                          </a> */}
                          <Button
                            className={styles['submit-btn']}
                            disabled={
                              selectedCard === 'null' &&
                              cardNumbersList.join('').length !== 16
                            }
                            onClick={(e) => {
                              // Modal.warning({
                              //   title: '發票歸戶功能維修中',
                              //   content:
                              //     '目前電子發票作業系統維護中，歸戶功能暫停使用，我們將會儘快修復，造成不便盼您諒解。',
                              // });
                              e.preventDefault()
                              this.submitData()
                            }}>
                            {__('開始歸戶', 'cec-plugin-stores')}
                          </Button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row no-gutters mx-n3 mb-4'>
                <div className='col-lg-3 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body d-flex justify-content-center align-items-center pb-0 pt-5 p-lg-5'>
                      <h5 className='h4 text-navy text-center'>注意事項</h5>
                    </div>
                  </div>
                </div>
                <div className='col-lg-9 px-3'>
                  <div className='card border-0 shadow-0 h-100'>
                    <div className='card-body p-5'>
                      <p className='h6 text-navy mb-4'>
                        {__(
                          '．自2025年9月16日起，會員名下之會員卡(包括實體好康卡及數位好康卡)，將統一整合至會員名下之GID開頭會員卡號, 當會員持名下任一會員卡號消費, 使用電子發票存於會員載具時, 會員載具皆會存於GID開頭之會員卡號。會員需重新選擇此組GID會員卡號進行歸戶。 此外，查詢電子發票交易時，需依據已歸戶的GID會員卡進行查詢。',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy mb-4'>
                        {__(
                          '．如您已於APP進行升級認證為uniopen會員，您的GID會員卡號將會整合為uniopen會員卡號。請您務必重新選擇此組GID會員卡號進行歸戶。',
                          'cec-plugin-stores',
                        )}
                      </p>
                      <p className='h6 text-navy mb-0'>
                        {__(
                          '．若進行歸戶作業將會使您離開網站，前往財政部電子發票平台，所有財政部電子發票平台，提供之網站及其內容（包括客戶隱私權及資訊安全）不屬於網站控制及責任範圍之內。',
                          'cec-plugin-stores',
                        )}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    )
  }
}

// 編輯器
const listGrid = { gutter: 16, xs: 1, sm: 2, md: 4, lg: 4, xl: 4, xxl: 4 }
export class UserInvoiceCarrierConsolidationEditor extends Component {
  formRef = React.createRef()
  state = {
    listInfo: _.cloneDeep(defaultListInfo),
  }
  componentDidMount() {
    AppHelper.updateConfig()
    console.log('kkk', this.props.attributes)

    this.formRef.current.setFieldsValue(this.props.attributes)
  }
  render() {
    const listInfo = this.state.listInfo
    const options = _.get(this, 'props.app.options', {})
    console.log('editor', this.props)

    return (
      <div className='wp-block-cec-vulcan-block-users-invoice-editor'>
        <h2>OCA發票歸戶</h2>
        <Form ref={this.formRef} name='basic' className='basicForm' />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/blocks/users/user-invoice-carrier-consolidation.js